import { useEffect, useRef } from "react";
import { useFormik } from "providers/FormProvider";
const useFilterForm = (args: any) => {
  const previousValues = useRef<any>({});
  const form = useFormik(args);
  useEffect(() => {
    // So sánh values hiện tại với values trước đó
    Object.keys(form.values).forEach((fieldName) => {
      const currentValue = form.values[fieldName];
      const previousValue = previousValues.current[fieldName];

      if (currentValue !== previousValue) {
        // Field changed
        const url = new URL(window.location.href);
        if (currentValue) {
          url.searchParams.set(fieldName, currentValue);
        } else {
          url.searchParams.delete(fieldName);
        }
        window.history.replaceState({}, "", url.toString());
      }
    });

    previousValues.current = { ...form.values };
  }, [form.values]);
  return form;
};

export default useFilterForm;
